'use strict';

angular.module('controlModule', [
    'searchModule',
    'aricModule'
]);